import { useEffect, useState } from "react";
import { map, upperFirst } from "lodash";
import { getLocateDate } from "../../../utils/format-date-time.utils";
import Button from "../../common/Button";
import { useNavigate } from "react-router-dom";
import AiChatModelService from "../../../services/ai-chat-models.service";
import { TAIChatModel } from "../../../types/chat-ai-models";

const AiModels = () => {
  const [aiModels, setAiModels] = useState<TAIChatModel[]>([]);
  const navigate = useNavigate();

  const getAIModels = async () => {
    try {
      const response = await AiChatModelService.getAll();
      if (response.data.data && response.data.data.models) {
        setAiModels(response.data.data.models);
      } else {
        console.log('Error: ', response.data.message);
      }
    } catch (err) {
      console.log('Error: ', err);
    }
  };

  useEffect(() => {
    getAIModels();
  }, []);

  return (
    <div className="overflow-y-auto w-full p-5">
      <div className="flex justify-between items-center mb-8">
        <h3 className='font-normal text-[40px]'>AI Chat Models</h3>
        <div><Button classes="bg-[#333] text-white" onClick={() => navigate('/ai-models/create')}>Create AI Model</Button></div>
      </div>
      <div className="overflow-x-auto p-5 rounded-2xl shadow-[0_0_8px_#cbcbcb]">
        <table className="text-[14px] bg-white min-w-full">
          <thead className="text-left">
            <tr className="text-[#616161]">
              <th className="p-3 min-w-[100px]">Platform</th>
              <th className="p-3 min-w-[100px]">Model Name</th>
              <th className="p-3 min-w-[100px]">Public Name</th>
              <th className="p-3 min-w-[100px]">Description</th>
              <th className="p-3 min-w-[100px]">Usage Multiplier</th>
              <th className="p-3 min-w-[100px]">Status</th>
              <th className="p-3 min-w-[100px]">Created At</th>
              <th className="p-3 min-w-[100px]"></th>
            </tr>
          </thead>
          <tbody className="text-[#333] font-regular">
            {map(aiModels, (aiModel) => (
              <tr className="static rounded-lg border-b-8 border-white last:border-none" key={aiModel._id}>
                <td className="px-3 py-5 first:font-semibold bg-[#fcfcfc]">{aiModel.platform}</td>
                <td className="px-3 py-5 bg-[#fcfcfc]">{aiModel.aiModelName}</td>
                <td className="px-3 py-5 bg-[#fcfcfc]">{aiModel.publicName}</td>
                <td className="px-3 py-5 bg-[#fcfcfc]">
                  {aiModel?.description ?? '--'}
                </td>
                <td className="px-3 py-5 bg-[#fcfcfc]">
                  {`x${aiModel?.usageMultiplier}`}
                </td>
                <td className="px-3 py-5 bg-[#fcfcfc]">
                  {upperFirst(aiModel?.status)}
                </td>
                <td className="px-3 py-5 bg-[#fcfcfc]">{aiModel?.createdAt && getLocateDate(aiModel?.createdAt.toString())}</td>
                <td className="px-3 py-5 bg-[#fcfcfc] cursor-pointer" onClick={() => navigate(`/ai-models/update/${aiModel._id}`)}>
                  <span className="font-bold">View Details</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default AiModels;